//
// WebContentType.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var WebContentType = {
    STANDARD:0,
    WEBDATACONTENT:1
};
export default WebContentType;
